import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

type EditCustomFieldWrapperOuterProps = {
    isEditModeOnIssueView: boolean;
};

export const EditCustomFieldWrapperOuter = styled.div<EditCustomFieldWrapperOuterProps>`
    box-sizing: border-box;
    ${props => props.isEditModeOnIssueView && 'height: 100vh;'}
    max-height: 550px;
    padding-right: 2px; //needed to prevent clipping of select shadow
    background-color: ${token('elevation.surface.overlay')};
`;

export const CustomFieldSelects = styled.div`
    padding-block-start: ${token('space.100')};
    padding-inline-end: ${token('space.050')};
    padding-block-end: ${token('space.150')};
`;

export const Spacer = styled.div`
    padding-top: 16px;
`;

export const ButtonWrapper = styled.div`
    justify-content: flex-end;
    display: flex;
`;

export const SectionTranslations = styled.h3`
    font-weight: 400;
`;

export const NoConfigWarning = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
`;

export const EditViewContainer = styled.div`
    position: relative;
    z-index: 300;
`;

export const ReadViewContainer = styled.div`
    position: relative;
    z-index: 300;
    padding-block-start: ${token('space.0')}!important;
    padding-inline-end: ${token('space.0')} !important;
    padding-block-end: ${token('space.0')} !important;
    & > *:not(:last-child) {
        margin-bottom: ${token('space.100')};
    }
`;

export const ThinBorder = {
    borderWidth: '1px',
};
